import { VariationsList } from './variations-list';

export { VariationsList };
